import { errorCellRenderer } from "../components/flowTable";
import { FlowTableColumn } from "../components/flowTable/types";

export const interfaceColumns: FlowTableColumn[] = [
  { data: "exportador", header: "Exportador", type: "text", width: 240 },
  { data: "interface", header: "Interface", type: "text", width: 240 },
  { data: "index", header: "Index", type: "text", width: 110 },
];

export const interfaceMassColumns = (
  exportadorOptions: string[],
): FlowTableColumn[] =>
  interfaceColumns.map((column) => ({
    ...column,
    ...(column.data === "exportador" && exportadorOptions.length > 0
      ? {
          type: "autocomplete" as const,
          source: exportadorOptions,
          strict: false,
        }
      : {}),
    renderer: errorCellRenderer,
  }));
